/**
 * Hide specific menu items from sidebar and profile dropdown
 */
export function hideMenuItems() {
  // Function to hide elements based on text content
  function hideByTextContent(selector, textPatterns) {
    const elements = document.querySelectorAll(selector);
    elements.forEach(element => {
      const text = element.textContent?.trim();
      if (textPatterns.some(pattern => text?.includes(pattern))) {
        element.style.display = 'none';
        // Also try to hide parent li or container
        const listItem = element.closest('li, [role="menuitem"], .sidebar-item');
        if (listItem) listItem.style.display = 'none';
      }
    });
  }

  // Function to hide by href patterns
  function hideByHref(patterns) {
    patterns.forEach(pattern => {
      const elements = document.querySelectorAll(`a[href*="${pattern}"]`);
      elements.forEach(el => {
        el.style.display = 'none';
        const listItem = el.closest('li, .sidebar-item');
        if (listItem) listItem.style.display = 'none';
      });
    });
  }

  // Main menu items to hide
  const mainMenuTexts = ['Captain', 'Help Center'];
  
  // Settings submenu items to hide
  const settingsMenuTexts = ['Inboxes', 'Automation', 'Audit Logs', 'Custom Roles', 'SLA', 'Security'];
  
  // Profile dropdown items to hide
  const profileMenuTexts = ['Keyboard Shortcuts', 'Change Appearance', 'Appearance', 'Read Documentation', 'Docs', 'Changelog'];

  // URL patterns to hide
  const urlPatterns = [
    '/captain',
    '/help',
    'settings/inbox',
    'settings/automation', 
    'auditlogs',
    'custom_roles',
    'sla',
    'security',
    'keyboard-shortcuts',
    'appearance',
    'documentation',
    'changelog'
  ];

  // Hide elements by text content
  hideByTextContent('span, a, button, [role="menuitem"]', mainMenuTexts);
  hideByTextContent('span, a, button, [role="menuitem"]', settingsMenuTexts);
  hideByTextContent('span, a, button, [role="menuitem"]', profileMenuTexts);

  // Hide by URL patterns
  hideByHref(urlPatterns);

  // Hide specific sidebar groups
  const sidebarGroups = document.querySelectorAll('[data-testid="sidebar-group"], .sidebar-group');
  sidebarGroups.forEach(group => {
    const text = group.textContent;
    if (text?.includes('Captain') || text?.includes('Help Center')) {
      group.style.display = 'none';
    }
  });
}

// Apply hiding when DOM is loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', hideMenuItems);
} else {
  hideMenuItems();
}

// Also apply when Vue updates the DOM
if (window.Vue) {
  // Apply after Vue component updates
  const observer = new MutationObserver(() => {
    hideMenuItems();
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// Export for manual use
export default hideMenuItems;